module.exports = __webpack_public_path__ + "static/media/ref_img.5ffeea95.jpg";